import {
    type BaseCurrencyType,
    type WalletCoinsBalance,
    type WalletCollectiblesBalance,
    type WalletCollectionsBalance,
    type WalletConnectedData,
} from '@pkg/types';

import { Jwt } from '@app/helpers';
import { callGetConnectedWalletsByUser } from '@app/store/zustand';
import { useAuthTokens } from '@app/store/zustand/Auth/useUserTokens';

import { useWalletStore } from './useWalletStore';

const ENABLED_CHAINS = ['apt', 'eth', 'matic'];

export async function initializeWalletsAsync() {
    const jwt = new Jwt(useAuthTokens.getState().token?.access_token);
    const userId = jwt.jwt?.sub;
    return (
        callGetConnectedWalletsByUser({
            variables: { includeCollections: false, includeCollectibles: false, includeCoins: true, userId },
            settings: {},
        })
            .then((res) => {
                const wallets = res?.accounts?.map((wallet) => {
                    const coins: WalletCoinsBalance[] = Object.keys(wallet.balance.coins)
                        .filter((currency) => ENABLED_CHAINS.includes(currency.toLowerCase()))
                        .map((currency) => ({
                            currency: currency.toLowerCase() as BaseCurrencyType,
                            value: wallet.balance.coins[currency].amount,
                        }));

                    const collectibles: WalletCollectiblesBalance[] = wallet.balance.collectibles
                        ? Object.values(wallet.balance.collectibles)
                        : [];

                    const collections: WalletCollectionsBalance[] = wallet.balance.collections
                        ? Object.values(wallet.balance.collections)
                        : [];

                    return {
                        // TODO: Should add the correct type of wallet
                        type: 'metamask',
                        walletAddress: wallet.address,
                        balances: {
                            coins,
                            collectibles,
                            collections,
                        },
                    } as WalletConnectedData;
                });

                // TODO: Avoid `.setState()` calls. Prefer explicit hook API instead.
                // We could call `clearWallets()` followed by `addWallets(wallets)`.
                useWalletStore.setState({ connectedWallets: wallets });
            })
            // eslint-disable-next-line no-console
            .catch((error) => console.error(error))
    );
}
